import { YesNoEmpty } from '@interfaces/models';
import { Action, createReducer, on } from '@ngrx/store';

import { StartOverStateCleared } from '../../actions/start-over/start-over.actions';
import * as trustActions from '../../actions/trust/trust.actions';

export interface TrustTaxInfoState {
  ein?: string;
  withholdingQuestion: YesNoEmpty;
  signature: string;
  date: string;
  ssn?: string;
  grantorName?: string;
  numberQuestion?: string;
  backupWithholdingSignatureName?: string;
  backupWithholdingAnswer?: 'yes' | 'no';
}

export const initialState: TrustTaxInfoState = {
  ein: '',
  withholdingQuestion: YesNoEmpty.EMPTY,
  signature: '',
  date: '',
  ssn: '',
  grantorName: '',
};

const trustTaxReducer = createReducer(
  initialState,
  on(trustActions.TrustTaxUpdate, (_state, { payload }) => ({
    ...payload,
  })),
  on(trustActions.TrustTaxBackupWithholdingSignatureNameUpdate, (state, { signatureName }) => ({
    ...state,
    backupWithholdingSignatureName: signatureName,
  })),
  on(trustActions.TrustTaxBackupWithholdingAnswerUpdate, (state, { answer }) => ({
    ...state,
    backupWithholdingAnswer: answer,
  })),
  on(StartOverStateCleared, () => ({ ...initialState })),
);

export function reducer(state: TrustTaxInfoState, action: Action) {
  return trustTaxReducer(state, action);
}
